import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";
// ? is it chatId or userId
const pathBase = `/chats/:userId/messages/`;
const pathById = `${pathBase}:messageId/`;

export type IChatPathParam = IExtractParams<typeof pathBase>;
export type IChatMessagePathParam = IExtractParams<typeof pathById>;

export const chats = {
  getAll: (param: IChatPathParam) => generatePath(pathBase, param),
  post: (param: IChatPathParam) => generatePath(pathBase, param),
  get: (param: IChatMessagePathParam) => generatePath(pathById, param),
  patch: (param: IChatMessagePathParam) => generatePath(pathById, param),
  delete: (param: IChatMessagePathParam) => generatePath(pathById, param),
};
